import { Layout, Typography, ConfigProvider, Button, Card } from "antd";
import { KycProvider } from "./kyc/context/KycProvider";
import { IconArrowNarrowLeft } from "@tabler/icons-react";
import { useNavigate } from "react-router";
import KycForm from "./kyc/components/KycForm";

const { Content } = Layout;
const { Title } = Typography;

const KycFlow = () => {
  const navigate = useNavigate();

  return (
    <div className="max-w-4xl mx-auto py-10 px-4">
      {/* Header */}
      <div className="mb-10 flex items-center justify-center relative">
        <div className="absolute left-0">
          <Button
            shape="circle"
            onClick={() => navigate(-1)}
            icon={<IconArrowNarrowLeft size={20} />}
            className="flex items-center justify-center border-gray-200 shadow-sm hover:shadow-md transition-all"
          />
        </div>

        <div className="text-center">
          <Title level={2} className="!mb-0">
            KYC Verification
          </Title>

          <Typography.Text type="secondary">
            Complete your KYC and bank details to start hosting events.
          </Typography.Text>
        </div>
      </div>

      {/* Content */}
      <div className="w-full flex justify-center items-center">
        <Card className="w-full max-w-3xl mx-auto shadow-md">
          <KycForm />
        </Card>
      </div>
    </div>
  );
};

const KycVerification = () => {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#000000",
          borderRadius: 8,
        },
      }}
    >
      <KycProvider>
        <Layout className="min-h-screen bg-gray-50">
          <Content>
            <KycFlow />
          </Content>
        </Layout>
      </KycProvider>
    </ConfigProvider>
  );
};

export default KycVerification;
